/** WorkOS widget token scope types supported by the identity API. */
export const WorkOSWidgetScopeType = {
  ORG_API_KEYS: 'org-api-keys',
  USER_API_KEYS: 'user-api-keys',
} as const;

export type WorkOSWidgetScopeType =
  (typeof WorkOSWidgetScopeType)[keyof typeof WorkOSWidgetScopeType];

export const WORKOS_WIDGET_SCOPE_TYPE_VALUES = [
  WorkOSWidgetScopeType.ORG_API_KEYS,
  WorkOSWidgetScopeType.USER_API_KEYS,
] as const satisfies readonly WorkOSWidgetScopeType[];

export interface WorkOSWidgetTokenRequest {
  widgetType: WorkOSWidgetScopeType;
}

export interface WorkOSWidgetTokenResponse {
  token: string;
}
